import {
  statutLabel,
  prioriteLabel,
  typeAppartLabel,
  localisationLabel,
  horizonLabel,
} from "@/lib/crmHelpers";

const HEADERS = [
  { key: "nom", label: "Nom" },
  { key: "telephone", label: "Téléphone" },
  { key: "email", label: "Email" },
  { key: "statut", label: "Statut", fmt: statutLabel },
  { key: "score", label: "Score" },
  { key: "priorite", label: "Priorité", fmt: prioriteLabel },
  { key: "type_appart", label: "Type", fmt: typeAppartLabel },
  { key: "localisation", label: "Localisation", fmt: localisationLabel },
  { key: "horizon", label: "Horizon", fmt: horizonLabel },
  { key: "budget", label: "Budget" },
  { key: "programme_immobilier", label: "Programme" },
  { key: "commercial", label: "Commercial" },
  { key: "source", label: "Source" },
  { key: "prochaine_action", label: "Prochaine action" },
  { key: "derniere_action", label: "Dernière action" },
  { key: "notes", label: "Notes" },
  { key: "created_at", label: "Créé le" },
];

const escape = (v) => {
  if (v == null) return "";
  const s = String(v).replace(/"/g, '""');
  return /[",;\n]/.test(s) ? `"${s}"` : s;
};

export function leadsToCSV(leads) {
  const head = HEADERS.map((h) => h.label).join(";");
  const rows = leads.map((l) =>
    HEADERS.map((h) => {
      const raw = l[h.key];
      return escape(h.fmt ? h.fmt(raw) : raw);
    }).join(";")
  );
  return [head, ...rows].join("\n");
}

export function downloadCSV(leads, filename = "leads_ryad.csv") {
  const csv = leadsToCSV(leads);
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
